import styled from "styled-components";
import HomeworkClassView from "./HomeworkClassView";
import useHomeworkProgressView from "features/homework/hooks/useHomeworkProgressView";
import HomeworkReportView from "./HomeworkReportView";
import HomeworkStudentView from "./HomeworkStudentView";
import HomeworkStudentListView from "./HomeworkStudentListView";
import HomeworkStudentReportView from "./HomeworkStudentReportView";
import HomeworkReportModal from "./HomeworkReportModal";
import { EmptyState, EmptyTitle, EmptyText } from "../homeworkUi";

const HomeworkProgressView = () => {
    const {selectedLesson, onLessonClickHandler, selectedStudent, onStudentClickHandler, selectedReport, onReportClickHandler, option, onOptionChangeHandler, onStudentAndLessonSelect } = useHomeworkProgressView();
    const hasSelection = option === "student" ? Boolean(selectedStudent) : Boolean(selectedLesson);

    const renderContent = () => {
        if (!hasSelection) {
            return (
                <EmptyState>
                    <EmptyTitle>{option === "student" ? "학생을 선택하세요" : "학급을 선택하세요"}</EmptyTitle>
                    <EmptyText>왼쪽 목록에서 항목을 고르면 과제 진행도가 표시됩니다.</EmptyText>
                </EmptyState>
            );
        }
        if(option === "student"){
            return <HomeworkStudentReportView selectedLesson={selectedLesson} selectedStudent={selectedStudent} onReportClickHandler={onReportClickHandler}/>
        }
        return selectedReport
            ? <HomeworkStudentView selectedLesson={selectedLesson} selectedReport={selectedReport} selectedStudent={selectedStudent} onStudentClickHandler={onStudentClickHandler}/>
            : <HomeworkReportView selectedLesson={selectedLesson} onReportClickHandler={onReportClickHandler}/>
    }

    return(
        <Container>
            {selectedReport && selectedStudent ? 
                <HomeworkReportModal
                    selectedLesson={selectedLesson} 
                    selectedStudent={selectedStudent} 
                    selectedReport={selectedReport} 
                    onConfirmClickHandler={() => {
                        if(option === "student"){
                            onReportClickHandler(undefined);
                        }else{
                            onStudentClickHandler(undefined);
                        }
                    }}
                /> 
                : null
            }
            <PageHeader>
                <PageTitle>진행도 조회</PageTitle>
                <PageDesc>학급 또는 학생을 선택한 뒤 과제 진행 현황을 확인하세요.</PageDesc>
            </PageHeader>
            <Body>
                <ListContainer>
                    <OptionContainer>
                        <OptionButton 
                            isSelected={option === "student"} 
                            optionType="student"
                            onClick={() => onOptionChangeHandler("student")}
                        >
                            학생
                        </OptionButton>
                        <OptionButton 
                            isSelected={option === "lesson"} 
                            optionType="lesson"
                            onClick={() => onOptionChangeHandler("lesson")}
                        >
                            학급
                        </OptionButton>
                    </OptionContainer>
                    {option === "student" ? <HomeworkStudentListView selectedLesson={selectedLesson} onStudentAndLessonSelect={onStudentAndLessonSelect} selectedStudent={selectedStudent}/> : <HomeworkClassView selectedLesson={selectedLesson} onLessonClickHandler={onLessonClickHandler}/>}
                </ListContainer>
                <ContentContainer>
                    {renderContent()}
                </ContentContainer>
            </Body>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    background: #F8FAFC;
`

const PageHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 20px 24px 0;
`

const PageTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #0F172A;
    letter-spacing: -0.02em;
`

const PageDesc = styled.p`
    margin: 0;
    font-size: 13px;
    color: #64748B;
`

const Body = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`

const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 20px 20px;
    flex: 1;
    min-height: 0;
    max-width: 430px;
    overflow: hidden;
    background: #F8FAFC;
    border-right: 1px solid #E2E8F0;
`

const ContentContainer = styled.div`
    padding: 16px 20px 20px;
    flex: 1;
    min-height: 0;
    overflow: auto;
    background: #F8FAFC;
    display: flex;
    flex-direction: column;
`

const OptionContainer = styled.div`
    display: flex;
    gap: 6px;
    margin-bottom: 12px;
    padding: 5px;
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
`

const OptionButton = styled.button<{ isSelected: boolean, optionType: string }>`
    flex: 1;
    padding: 12px 20px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background: ${props => props.isSelected ? '#DF0000' : 'transparent'};
    color: ${props => props.isSelected ? '#FFFFFF' : '#4B5563'};

    &:hover {
        background: ${props => props.isSelected ? '#B91C1C' : '#F3F4F6'};
    }

    &:active {
        transform: scale(0.98);
    }
`

export default HomeworkProgressView;